/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_create_custom_workspace_role_v1_workspaces__slug__workspace_roles_custom_post } from '../models/Body_create_custom_workspace_role_v1_workspaces__slug__workspace_roles_custom_post';
import type { Body_update_custom_workspace_role_v1_workspaces__slug__workspace_roles__role_id__patch } from '../models/Body_update_custom_workspace_role_v1_workspaces__slug__workspace_roles__role_id__patch';
import type { WorkspaceRoleWithPermissions } from '../models/WorkspaceRoleWithPermissions';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WorkspaceRolesService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Workspace Roles
   * @param slug
   * @returns WorkspaceRoleWithPermissions Successful Response
   * @throws ApiError
   */
  public getWorkspaceRolesV1WorkspacesSlugWorkspaceRolesGet(
    slug: string
  ): CancelablePromise<Array<WorkspaceRoleWithPermissions>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/workspace-roles',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Custom Workspace Role
   * @param slug
   * @param requestBody
   * @returns WorkspaceRoleWithPermissions Successful Response
   * @throws ApiError
   */
  public createCustomWorkspaceRoleV1WorkspacesSlugWorkspaceRolesCustomPost(
    slug: string,
    requestBody: Body_create_custom_workspace_role_v1_workspaces__slug__workspace_roles_custom_post
  ): CancelablePromise<WorkspaceRoleWithPermissions> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/workspace-roles/custom',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid permissions`,
        401: `Unauthorized`,
        403: `Insufficient privileges`,
        409: `Role already exists`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Custom Workspace Role
   * @param roleId
   * @param slug
   * @param requestBody
   * @returns WorkspaceRoleWithPermissions Successful Response
   * @throws ApiError
   */
  public updateCustomWorkspaceRoleV1WorkspacesSlugWorkspaceRolesRoleIdPatch(
    roleId: number,
    slug: string,
    requestBody: Body_update_custom_workspace_role_v1_workspaces__slug__workspace_roles__role_id__patch
  ): CancelablePromise<WorkspaceRoleWithPermissions> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/workspaces/{slug}/workspace-roles/{role_id}',
      path: {
        role_id: roleId,
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid permissions`,
        401: `Unauthorized`,
        403: `Insufficient privileges`,
        404: `Role not found`,
        409: `Role already exists`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Delete Custom Workspace Role
   * @param roleId
   * @param slug
   * @returns void
   * @throws ApiError
   */
  public deleteCustomWorkspaceRoleV1WorkspacesSlugWorkspaceRolesRoleIdDelete(
    roleId: number,
    slug: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/workspaces/{slug}/workspace-roles/{role_id}',
      path: {
        role_id: roleId,
        slug: slug,
      },
      errors: {
        403: `Insufficient privileges`,
        404: `Role not found`,
        409: `Role still has members`,
        422: `Validation Error`,
      },
    });
  }
}
